import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import ProtectedRoute from './ProtectedRoute';
import Transactions from 'views/user/Transactions';
import Profile from 'views/user/Profile';
import Support from 'views/other/Support';
import Devices from 'views/user/Devices';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/homes')));

// utilities routing
const Services = Loadable(lazy(() => import('views/utilities/Services')));
const DataService = Loadable(lazy(() => import('views/utilities/Data')));
const InternetService = Loadable(lazy(() => import('views/utilities/Internet')));
const AirtimeService = Loadable(lazy(() => import('views/utilities/Airtime')));
const ElectricityService = Loadable(lazy(() => import('views/utilities/Electricity')));
const CableService = Loadable(lazy(() => import('views/utilities/Cable')));
const ResultCheckService = Loadable(lazy(() => import('views/utilities/ResultCheck')));

const Referrals = Loadable(lazy(() => import('views/user/Referrals')));
const FundingOptions = Loadable(lazy(() => import('views/user/FundingOption')));

const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const PlanPricing = Loadable(lazy(() => import('views/documentation')));
const APIDocs = Loadable(lazy(() => import('views/documentation/ApiDoc')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <ProtectedRoute component={<MainLayout />} />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <DashboardDefault />
                }
            ]
        },
        {
            path: 'user',
            children: [
                {
                    path: 'transactions',
                    element: <Transactions />
                }
            ]
        },
        {
            path: 'user',
            children: [
                {
                    path: 'profile',
                    element: <Profile />
                }
            ]
        },
        {
            path: 'device-management',
            element: <Devices />
        },
        {
            path: 'more',
            children: [
                {
                    path: 'support',
                    element: <Support />
                }
            ]
        },
        {
            path: 'referrals',
            element: <Referrals />
        },
        {
            path: 'funding-options',
            element: <FundingOptions />
        },
        {
            path: 'services',
            element: <Services />
        },
        {
            path: 'services',
            children: [
                {
                    path: 'data',
                    element: <DataService />
                }
            ]
        },
        {
            path: 'services',
            children: [
                {
                    path: 'airtime',
                    element: <AirtimeService />
                }
            ]
        },
        {
            path: 'services',
            children: [
                {
                    path: 'internet',
                    element: <InternetService />
                }
            ]
        },
        {
            path: 'services',
            children: [
                {
                    path: 'electricity',
                    element: <ElectricityService />
                }
            ]
        },
        {
            path: 'services',
            children: [
                {
                    path: 'cable',
                    element: <CableService />
                }
            ]
        },
        {
            path: 'services',
            children: [
                {
                    path: 'result-checker',
                    element: <ResultCheckService />
                }
            ]
        },

        {
            path: 'plans-list',
            element: <PlanPricing />
        },
        {
            path: 'api-docs',
            element: <APIDocs />
        }
    ]
};

export default MainRoutes;
